var Catalogue, CatalogueController, CataloguePageView, Chaplin, Controller, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Controller = require('controllers/base/controller');

CataloguePageView = require('views/catalogue-page-view');

Catalogue = require('models/catalogue');

Chaplin = require('chaplin');

module.exports = CatalogueController = (function(_super) {
  __extends(CatalogueController, _super);

  function CatalogueController() {
    _ref = CatalogueController.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  CatalogueController.prototype.catalogue = function(options) {
    var model;
    model = new Catalogue({
      id: options != null ? options.catalogue : void 0
    });
    model.fetch();
    this.view = new CataloguePageView({
      region: 'main',
      model: model
    });
    return Chaplin.mediator.catalogue = model;
  };

  CatalogueController.prototype.index = function() {
    return this.redirectTo('catalogue/1876');
  };

  return CatalogueController;

})(Controller);
